const config = {
	backend: process.env.REACT_APP_BACKEND,
};

export default config;
